module.exports = __webpack_public_path__ + "static/media/foodora-logo600.843cd014.png";